import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const sid = sp.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState("paid");
          const email = sessionStorage.getItem("bomber_pay_email") || "";
          timer = setTimeout(() => nav(`/track?code=${data.order_code}${email ? `&email=${encodeURIComponent(email)}` : ""}`), 1500);
          return;
        }
        if (data.status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      if (tries >= 20) { setState("slow"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, nav]);

  return (
    <div className="max-w-xl mx-auto px-5 pt-24 text-center" data-testid="payment-success-page">
      <div className="overline-label mb-4">// payment</div>
      <h1 className="font-display text-6xl chrome-text mb-6">{state === "paid" ? "Payment confirmed" : state === "error" ? "Payment problem" : "Confirming payment"}</h1>
      <p className="text-[#aaa]" data-testid="payment-success-message">
        {state === "checking" && "Hold tight. We are confirming your card payment and unlocking your transfer pack..."}
        {state === "paid" && "Done. Taking you to your order and secure transfer pack..."}
        {state === "slow" && "Still confirming. Your order will update automatically. Check it on the track page in a minute."}
        {state === "error" && "We could not confirm this payment. If you were charged, contact support with your order code."}
      </p>
      <Link to="/track" className="btn-bomb inline-block mt-8" data-testid="payment-success-track-link">Track order</Link>
    </div>
  );
}

export function PaymentCancel() {
  const [sp] = useSearchParams();
  return (
    <div className="max-w-xl mx-auto px-5 pt-24 text-center" data-testid="payment-cancel-page">
      <div className="overline-label mb-4">// payment</div>
      <h1 className="font-display text-6xl chrome-text mb-6">Payment cancelled</h1>
      <p className="text-[#aaa]">No charge was made. Your order is still reserved. You can pay by card or OSRS GP any time from the track page.</p>
      <Link to={`/track?code=${sp.get("code") || ""}`} className="btn-bomb inline-block mt-8" data-testid="payment-cancel-track-link">Back to my order</Link>
    </div>
  );
}
